import { Injectable } from "@angular/core";
import { SaleOrder } from "@tendercuts/models";
import { PosQuote } from '../../models';

@Injectable({ providedIn: "root" })
export class QuoteSerializerService {
  constructor() {}

  /**
   * serialized quote for save order in firebase
   * @param quote
   * @param storeId
   */
  quoteToSaleOrderSerializer(quote: PosQuote, storeId) {
    const products = quote.cartProducts.map((product) => {
      return { id: product.productId, q: product.quantity };
    });

    /**
     we added new payment methods (cardforpos and upiforpos)
     for Pinelabs integration, but our system in the backend 
     and ERP is configured with ccforpos for the card and UPI payments. 
     if we change here overall audit will broken.
    */
    if (
      quote.paymentMethod === "cardforpos" ||
      quote.paymentMethod === "upiforpos"
    ) {
      quote.paymentMethod = "ccforpos";
      quote.cardNumber = quote.plutusTransactionReferenceID;
    }

    return {
      x: 0,
      s: storeId,
      tc: quote.tenderCash,
      cc: quote.changeCash,
      ti: quote.transactionId,
      cn: quote.cardNumber,
      id: quote.orderId,
      u: quote.user.fireBaseSerialize(),
      c: quote.couponCode ? quote.couponCode : null,
      p: products,
      pay: quote.paymentMethod,
      rp: quote.totals.rewardPointsSpend,
      d: quote.totals.discount.toFixed(2),
      gt: quote.totals.grandTotal.toFixed(2),
      dt: new Date().toLocaleString(),
      v: "3.7.41",
      ptr: quote.plutusTransactionReferenceID
        ? quote.plutusTransactionReferenceID
        : null,
    };
  }

  /**
   * serialized quote for save quote in firebase
   * @param quote
   * @param storeId
   */
  quoteToVoidQuoteSerializer(quote: PosQuote, storeId, cancelReason: string) {
    const products = quote.cartProducts.map(product => {
      return { id: product.productId, q: product.quantity };
    });
    return {
      x: 0,
      s: storeId,
      p: products,
      cr: cancelReason,
      dt: new Date().toLocaleString()
    };
  }


  /**
   * converting saleorder to posquote
   * @param order
   */
  public posQuoteSerializer(order: SaleOrder) {
    const quote = {
      status: order.status,
      cartProducts: order.items,
      user: {
        entity_id: order.customerId,
        firstname: order.firstname,
        group_id: order.groupId 
      },
      reward_points_sepnd: order.rewardAmount,
      payment_method: order.paymentMethod,
      created_at: order.createdAt,
      order_id: order.incrementId,
      medium: order.medium,
      totals: {
        subtotal: order.subtotal,
        discount: order.discount,
        taxAmount: order.taxAmount,
        rewardPointsSpend: order.rewardAmount,
        grandTotal: order.total,
        rewardPointsEarn: order.rewardPointsEarn,
        eliteSavingsPos: order.eliteSaving
      },
      coupon_code: order.couponCode
    };
    return new PosQuote().deserialize(quote);
  }
}
